<template>
	<div v-if="showSubscribeToPushPromo" class="challenge-item">
		<div class="block-default" :class="{desktop: !isMobile}">
			<div class="d-flex">
				<div class="challenge-image">
					<ResponsiveImage :height-proportion="100" image="/challenge-images/phone-ok.png" />
				</div>

				<div class="challenge-main-block">
					<div class="title">
						{{ t.pushNotificationsPromoTitle }}
					</div>

					<div class="challenge-intro-text">
						{{ t.pushNotificationsPromoDescription }}
					</div>

					<div v-if="!isMobile" class="button-row">
						<button class="btn-accept pull-right" @click="enablePushNotifications">
							<font-awesome-icon icon="fa-regular fa-bell" />
							{{ t.pushNotificationsPromoButton }}
						</button>
					</div>
				</div>
			</div>
			
			<div v-if="isMobile" class="button-row">
				<button class="btn-accept pull-right" @click="enablePushNotifications">
					<font-awesome-icon icon="fa-regular fa-bell" />
					{{ t.pushNotificationsPromoButton }}
				</button>
			</div>
		</div>
	</div>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from '@/js/stores/index';
import ResponsiveImage from '../blocks/responsive-image.vue';
import { enablePushNotifications } from '@/js/includes/service-worker/notifications';

const store = useStore()

// Computeds
const t = computed(() => store.translations)
const isMobile = computed(() => store.isMobile)
const showSubscribeToPushPromo = computed(() => store.isPushSetUp && store.isPushNotDenied && !store.isPushGranted)
</script>
